module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step1b_Image18.0c52d72e.jpg";